import { useEffect, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    CircularProgress,
    Box
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import "./FEUReportSummary.scss";
import FEUChildEnergyConsumption from "./FEUChildEnergyConsumption/FEUChildEnergyConsumption";
import FEUChildDerogations from "./FEUChildDerogations/FEUChildDerogations";
import { FEU_CHILD_API_ROUTES } from "../../FEUChildApiRoutes";
import { callApi } from "../../../../../../services/MonitoringPlanService";
import { useSelector } from "react-redux";

const FEUReportSummary = () => {
    const [expanded, setExpanded] = useState("energy");
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false); 

    const reportDetails = useSelector(
        (state) => state.reports.selectedReportDetails
    );

    const handleChange = (panel) => (_, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const renderAccordionHeader = (title, isExpanded) => (
        <>
            {isExpanded ? (
                <RemoveIcon sx={{ marginRight: 1, fontSize: "18px" }} />
            ) : (
                <AddIcon sx={{ marginRight: 1, fontSize: "18px" }} />
            )}
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                {title}
            </Typography>
        </>
    );

    const fetchReportSummaryData = async (reportMstId) => {
        try {
            setLoading(true); 
            const response = await callApi({
                method: "GET",
                url: FEU_CHILD_API_ROUTES.GET_REPORT_SUMMARY(reportMstId),
                data: {},
            });
            if (response) {
                setData(response);
            }
        } catch (error) {
            console.error("Error fetching energy monitoring data", error);
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        if (reportDetails?.ReportMstId) {
            fetchReportSummaryData(reportDetails?.ReportMstId);
        }
    }, [reportDetails?.ReportMstId]);

    return (
        <form>
            {/* Accordion 1 - Energy Consumption */}
            <Accordion
                expanded={expanded === "energy"}
                onChange={handleChange("energy")}
                className="mt-2 header-text"
            >
                <AccordionSummary aria-controls="panel1-content" id="panel1-header">
                    {renderAccordionHeader("Energy Consumption", expanded === "energy")}
                </AccordionSummary>
                <AccordionDetails>
                    {loading ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "120px",
                            }}
                        >
                            <CircularProgress size={28} />
                        </Box>
                    ) : (
                        <Typography variant="body2">
                            <FEUChildEnergyConsumption energyConsumption={data?.energyConsumption} />
                        </Typography>
                    )}
                </AccordionDetails>
            </Accordion>

            {/* Accordion 2 - Derogations */}
            <Accordion
                expanded={expanded === "derogations"}
                onChange={handleChange("derogations")}
                className="mt-2 header-text"
            >
                <AccordionSummary aria-controls="panel2-content" id="panel2-header">
                    {renderAccordionHeader("Derogations", expanded === "derogations")}
                </AccordionSummary>
                <AccordionDetails>
                    {loading ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "120px",
                            }}
                        >
                            <CircularProgress size={28} />
                        </Box>
                    ) : (
                        <Typography variant="body2">
                            <FEUChildDerogations
                                windDerogations={data?.derogations?.windDerogations}
                                iceDerogations={data?.derogations?.iceDerogations}
                            />
                        </Typography>
                    )}
                </AccordionDetails>
            </Accordion>
        </form>
    );
};

export default FEUReportSummary;
